/**
 * Sticky Add-to-Cart Bar
 * Shows a fixed bottom bar when the original buy button scrolls out of view.
 */
(function () {
  const bar = document.getElementById('StickyAddToCart');
  if (!bar) return;

  const originalBtn = document.querySelector('.product-form__submit');
  if (!originalBtn) return;

  /* ── Show / Hide via IntersectionObserver ── */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Show sticky bar when original button is NOT visible
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0, rootMargin: '0px' }
  );
  observer.observe(originalBtn);

  /* ── Sync variant changes ── */
  const stickySelect = bar.querySelector('.sticky-atc__select');
  const stickyBtn = bar.querySelector('.sticky-atc__btn');
  const stickyPrice = bar.querySelector('.sticky-atc__price');

  if (stickySelect) {
    // When sticky variant changes → propagate to main variant-selects (radios/select)
    // so Rise dispatches PUB_SUB events and updates image, price, URL, etc.
    stickySelect.addEventListener('change', function () {
      const variantId = this.value;
      const variant = (window.stickyAtcVariants || []).find(
        (v) => String(v.id) === String(variantId)
      );
      if (!variant) return;

      // 方針: Rise の variant cascade (section 再描画 → スクロールジャンプ) を発火させない。
      // 1) sticky 側の見た目を即更新
      // 2) hidden input にだけ variantId を書き込む（form submit 用）
      // 3) main の variant radio も silently checked にする（スクロールしてもUI整合）
      // 4) input イベントは飛ばさない（preorder banner JS が 300ms polling で拾うので OK）
      syncStickyFromVariant(variantId);

      const originalForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (originalForm) {
        const hiddenInput = originalForm.querySelector('input.product-variant-id');
        if (hiddenInput) {
          // value 属性を更新（再描画には繋がらない、polling で picked up）
          hiddenInput.value = variantId;
          hiddenInput.setAttribute('value', variantId);
        }
      }

      const variantSelects = document.querySelector('variant-selects, variant-radios');
      if (variantSelects && Array.isArray(variant.options)) {
        variant.options.forEach(function (optValue) {
          Array.from(
            variantSelects.querySelectorAll('input[type="radio"]')
          ).forEach(function (r) {
            r.checked = r.value === optValue;
          });
          // Select element も静かに同期
          Array.from(variantSelects.querySelectorAll('select option')).forEach(function (o) {
            if (o.value === optValue) o.selected = true;
          });
        });
      }
    });

    // Listen for variant changes from the original page
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        syncStickyFromVariant(e.detail.variant.id);
      }
    });

    // Also watch for changes to the hidden variant input
    const originalForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (originalForm) {
      const hiddenInput = originalForm.querySelector('input.product-variant-id');
      if (hiddenInput) {
        const inputObserver = new MutationObserver(function () {
          const newVal = hiddenInput.value;
          if (newVal && stickySelect.value !== newVal) {
            syncStickyFromVariant(newVal);
          }
        });
        inputObserver.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
      }
    }
  }

  /* ── Helper: sticky 側 (select / image / price / button) を variantId に合わせる ── */
  function syncStickyFromVariant(variantId) {
    const variant = (window.stickyAtcVariants || []).find(
      (v) => String(v.id) === String(variantId)
    );
    if (!variant) return;
    if (stickySelect && stickySelect.value !== String(variantId)) {
      stickySelect.value = String(variantId);
    }
    const stickyImg = bar.querySelector('.sticky-atc__img');
    if (stickyImg) {
      const img = variant.featured_image;
      if (img && img.src) {
        stickyImg.src = img.src;
      }
    }
    updateStickyPrice(variantId);
    updateStickyButton(variantId);
  }

  /* ── Add-to-Cart click ── */
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Click the original submit button to use existing form/cart logic
      const origSubmit = document.querySelector('.product-form__submit');
      if (origSubmit && !origSubmit.disabled) {
        origSubmit.click();
      }
    });
  }

  /* ── Helper: Update price from variant data ── */
  function updateStickyPrice(variantId) {
    if (!stickyPrice || !window.stickyAtcVariants) return;
    const variant = window.stickyAtcVariants.find(
      (v) => String(v.id) === String(variantId)
    );
    if (variant) {
      stickyPrice.textContent = formatMoney(variant.price);
    }
  }

  /* ── Helper: Update button disabled state ── */
  function updateStickyButton(variantId) {
    if (!stickyBtn || !window.stickyAtcVariants) return;
    const variant = window.stickyAtcVariants.find(
      (v) => String(v.id) === String(variantId)
    );
    if (variant) {
      // [MIYAGEN 2026-06-15] btob-only(卸専売)は variant 変更後も常に SOLD OUT のまま
      var btob = window.miyagenBtobOnly === true;
      stickyBtn.disabled = btob || !variant.available;
      stickyBtn.querySelector('span').textContent = (!btob && variant.available)
        ? (document.documentElement.lang === 'en' ? 'Add to cart' : 'カートに追加する')
        : (document.documentElement.lang === 'en' ? 'Sold out' : '売り切れ');
    }
  }

  /* ── Format money (JPY) ── */
  function formatMoney(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }
})();
